import React from "react";

import Table from "../../common/Table";
import Option from "../../common/RowOption";
import DownloadIcon from "../../../icons/download-icon";

import lbl from "../../../data/Labels.json";

const SubAccountsExpensesList = ({ data, query, params = {} }) => {
  const getPrintRoute = (e) => {
    return (
      `expense-payment-receipt/` +
      `types/${params.type}` +
      `/accounts/${params.account}` +
      `/subAccounts/${params.subAccount}` +
      `/expenses/${e.id}` +
      `/halfYear/${params.halfYear}`
    );
  };
  const columns = [
    { path: "id", label: "شماره" },
    { path: "payment_date", label: "تاریخ پرداخت" },
    { path: "contractor", label: "طرف قرارداد" },
    { path: "paid_by_staff", label: "پرداخت کننده" },
    { path: "account", label: "حساب" },
    { path: "remark", label: "ملاحظه" },
    { path: "bank_ref_no", label: "ریفرنس نمبر" },
    {
      path: "attachment",
      label: "سند",
      content: ({ attachment }) =>
        attachment ? (
          <a
            className="attachment-download-link"
            href={attachment}
            download
            target="_blank"
            rel="noopener noreferrer"
            title={lbl.Download || "دانلود"}
            aria-label={lbl.Download || "دانلود"}
          >
            <DownloadIcon />
          </a>
        ) : (
          "—"
        ),
    },
    { path: "amount", label: "مبلغ" },
    {
      path: "option",
      content: (e) => (
        <Option
          Edit={{ form: "expense-form", cache: e.id, edit: e }}
          Delete={{ route: "expenses", id: e.id }}
          Print={{ route: getPrintRoute(e) }}
        />
      ),
    },
  ];

  return <Table data={data} columns={columns} query={query} />;
};

export default SubAccountsExpensesList;
